import React from 'react'

import { LanguageButton } from './LanguageButton'
import { getLanguageTooltipDescription } from './languageDescriptionUtils'
import { MeetingLanguage, RoomSessionLanguageConfig } from '../../models/Room'
import { isLanguageCalculated, useLanguageOptions } from '../../common/languageUtils'
import { LanguageTooltip } from './LanguageTooltip'
import { Stack } from 'react-bootstrap'

export interface LanguageInfoButtonProps {
  languageConfig: RoomSessionLanguageConfig | null
  onLanguageClicked: () => void
}

export interface LanguageInfoProps {
  languageConfig: RoomSessionLanguageConfig | null
}

export const LanguageInfoButton: React.FC<LanguageInfoButtonProps> = ({ languageConfig, onLanguageClicked }) => {
  const { getLabel } = useLanguageOptions()

  if (!languageConfig) {
    return null
  }

  const tooltipDescription = getLanguageTooltipDescription(languageConfig, getLabel)
  const isCalculated = isLanguageCalculated(languageConfig)

  return (
    <LanguageButton
      language={languageConfig.language ? languageConfig.language : MeetingLanguage.ENGLISH}
      tooltipText={tooltipDescription ?? undefined}
      onLanguageClick={onLanguageClicked}
      isCalculated={isCalculated}
    />
  )
}

export const LanguageInfo: React.FC<LanguageInfoProps> = ({ languageConfig }) => {
  const { getLabel } = useLanguageOptions()

  if (!languageConfig) {
    return null
  }
  const isCalculated = isLanguageCalculated(languageConfig)
  const tooltipText = "Determined based on clients' languages. Review in Meeting Prep."

  const content = (
    <Stack direction='horizontal' gap={1}>
      <i className='text-black bi bi-globe2' />
      <span className='paragraph-small'>{getLabel(languageConfig.language)}</span>
      {isCalculated ? <i className='zocks-text-warning-light bi bi-circle-fill' style={{ fontSize: '0.5rem' }} /> : null}
    </Stack>
  )

  if (!isCalculated) {
    return content
  }

  return <LanguageTooltip tooltipText={tooltipText}>{content}</LanguageTooltip>
}
